import styled from 'styled-components';

export const Gallery = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  padding: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const GalleryItem = styled.div`
  position: relative;
  aspect-ratio: ${props => props.big ? '16/9' : '1/1'};
  grid-column: ${props => props.big ? 'span 2' : 'span 1'};
  overflow: hidden;
  background-color: #f5f5f5;

  @media (max-width: 768px) {
    grid-column: span 1;
  }

  &:hover {
    .overlay {
      opacity: 1;
    }
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;

  ${GalleryItem}:hover & {
    transform: scale(1.05);
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  padding: 2rem;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 0.5rem;
  color: #000;
`;

export const Tags = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 1.5rem;
`;

export const Description = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 1.5rem;

  display: -webkit-box;
  -webkit-line-clamp: 5;       /* Limit to 3 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  // white-space: normal;
`;

export const ViewText = styled.span`
  font-size: 1rem;
  color: #000;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  border-bottom: 1px solid #000;
  padding-bottom: 0.2rem;
`; 